import { theme } from "src/theme/theme";

const SolveDurationIcon = ({ width = "170", height = "124" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 170 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_11_15627)">
        <path
          d="M22.3445 52.3564C22.6361 52.2589 22.8305 51.9663 22.8305 51.5761L22.6361 50.7959C22.5389 50.5033 22.2473 50.3082 21.9557 50.4057L14.5684 52.3564C14.2768 52.4539 14.0824 52.7465 14.1796 53.0391L14.374 53.8194C14.4712 54.112 14.7628 54.307 15.0544 54.2095C15.346 55.2823 16.1236 56.1601 17.0956 56.7453L18.3592 57.428C18.5536 57.5256 18.5536 57.7206 18.4564 57.8182L17.5816 58.9886C16.9012 59.8663 16.7068 61.0367 16.9012 62.1096C16.6096 62.2071 16.4152 62.4997 16.5124 62.7923L16.7068 63.5726C16.804 64.0602 17.1928 64.2553 17.4844 64.1578L24.8717 62.2071C25.1633 62.1096 25.3577 61.817 25.2605 61.5244L25.0661 60.7441C24.9689 60.4515 24.6773 60.2565 24.3857 60.354C24.0941 59.2812 23.3165 58.4034 22.3445 57.9157L20.9836 57.233C20.7892 57.1355 20.7892 56.9404 20.8864 56.8429L21.7612 55.6725C22.3445 54.5996 22.5389 53.5268 22.3445 52.3564ZM20.5948 54.7947L19.6228 56.1601C19.5256 56.3552 19.234 56.3552 19.1368 56.2577L17.6788 55.4774C17.0956 55.1848 16.7068 54.7947 16.4152 54.2095C16.318 54.0144 16.4152 53.8194 16.6096 53.7218C16.6096 53.7218 16.6096 53.7218 16.7068 53.7218L20.7892 52.649C20.9836 52.649 21.178 52.7465 21.178 52.9416C21.178 52.9416 21.178 52.9416 21.178 53.0391C21.0808 53.7218 20.9836 54.307 20.5948 54.7947Z"
          fill={theme.colors.primary[500]}
        />
      </g>
      <path
        d="M81.929 104.633C108.609 104.633 130.238 82.9311 130.238 56.1599C130.238 29.3888 108.609 7.68652 81.929 7.68652C55.2487 7.68652 33.6201 29.3888 33.6201 56.1599C33.6201 82.9311 55.2487 104.633 81.929 104.633Z"
        fill="#EAEEF9"
      />
      <path
        d="M137.196 32.3618C138.702 30.9809 138.807 28.6366 137.431 27.1256C136.055 25.6146 133.719 25.5091 132.213 26.8899C130.707 28.2708 130.602 30.6151 131.978 32.1261C133.354 33.6371 135.691 33.7426 137.196 32.3618Z"
        fill="#EAEEF9"
      />
      <path
        d="M54.0105 11.8464C55.2868 11.4301 55.9851 10.0545 55.5703 8.77389C55.1555 7.49324 53.7845 6.7925 52.5082 7.20874C51.2319 7.62497 50.5336 9.00057 50.9484 10.2812C51.3632 11.5619 52.7342 12.2626 54.0105 11.8464Z"
        fill="#EAEEF9"
      />
      <path
        d="M59.3146 3.8911C60.1825 3.60805 60.6574 2.67263 60.3753 1.80179C60.0932 0.930943 59.161 0.454442 58.2931 0.737492C57.4252 1.02054 56.9504 1.95596 57.2324 2.8268C57.5145 3.69765 58.4468 4.17415 59.3146 3.8911Z"
        fill="#EAEEF9"
      />
      <path
        d="M137.476 15.7463C138.11 15.1649 138.154 14.1779 137.575 13.5416C136.995 12.9054 136.012 12.861 135.378 13.4424C134.743 14.0238 134.699 15.0109 135.279 15.6471C135.858 16.2833 136.842 16.3277 137.476 15.7463Z"
        fill="#EAEEF9"
      />
      <path
        d="M99.1059 4.11265C99.5418 3.71294 99.5723 3.03433 99.1739 2.59694C98.7755 2.15954 98.0992 2.12899 97.6633 2.5287C97.2274 2.92841 97.197 3.60702 97.5953 4.04442C97.9937 4.48181 98.67 4.51236 99.1059 4.11265Z"
        fill="#EAEEF9"
      />
      <path
        d="M88.0277 5.46169C87.7361 5.1691 87.3473 4.8765 86.9585 4.58391V4.48637C86.9585 4.48637 87.0557 4.38884 87.1529 4.38884C87.4445 4.19378 87.7361 3.90118 87.8333 3.60859C87.9305 3.02339 87.4445 2.82833 87.1529 2.63327C87.1529 2.63327 87.0557 2.63327 87.0557 2.53573L87.1529 2.4382C87.4445 2.24314 87.7361 1.85301 87.7361 1.46288C87.7361 1.26782 87.5417 1.07275 87.3473 1.07275C87.1529 1.07275 86.9585 1.26782 86.9585 1.46288C86.9585 1.56041 86.7641 1.75548 86.6669 1.85301C86.4725 2.04807 86.1809 2.34067 86.1809 2.7308C86.2781 3.02339 86.4725 3.21846 86.7641 3.31599C86.8613 3.31599 86.9585 3.41352 86.9585 3.41352C86.9585 3.51105 86.7641 3.60859 86.6669 3.70612C86.4725 3.80365 86.3753 3.99871 86.1809 4.09625C86.1809 4.09625 86.0837 4.09625 86.0837 3.99871C85.8893 3.90118 85.6949 3.80365 85.5005 3.70612C85.4033 3.70612 85.3061 3.60859 85.2089 3.60859C84.5285 3.41352 84.0425 3.51105 83.6536 3.90118C83.5564 3.99871 83.4592 4.09625 83.4592 4.29131L80.7376 12.0939C80.6404 12.3865 80.7376 12.6791 81.0292 12.7766C81.1264 12.7766 81.3208 12.7766 81.418 12.7766L88.9025 9.94817H88.9997C89.0969 9.85064 89.1941 9.85063 89.2913 9.7531C89.5829 9.46051 89.6801 9.07038 89.6801 8.68025C89.5829 7.9 89.3885 7.21727 88.9025 6.63208C88.7081 6.24195 88.4165 5.85182 88.0277 5.46169ZM88.8053 9.26544C88.5137 9.55804 87.1529 9.26544 85.6949 7.80246C84.3341 6.33948 84.0424 4.97403 84.3341 4.68144C84.5285 4.48637 85.1117 4.58391 85.8893 4.97403L85.6949 5.26663C85.5977 5.46169 85.5977 5.65676 85.7921 5.85182C85.8893 5.85182 85.8893 5.94935 85.9865 5.94935C86.0837 5.94935 86.2781 5.85182 86.2781 5.75429L86.4725 5.46169C86.7641 5.65676 87.0557 5.94935 87.3473 6.24195C88.8053 7.50987 89.0969 8.97285 88.8053 9.26544Z"
        fill="url(#paint1_linear_11_15627)"
      />
      <path
        d="M93.2769 6.33975C93.1797 6.43728 92.8881 6.24222 92.6937 6.14469C92.4021 5.94962 91.9161 5.75456 91.6245 6.04716C91.3329 6.33975 91.4301 6.63235 91.4301 7.02248C91.4301 7.12001 91.4301 7.21754 91.4301 7.31507C91.2357 7.21754 91.1385 7.12001 90.9441 7.02248C90.6525 6.82741 90.1665 6.53482 89.7777 6.92494C89.6805 7.12001 89.6805 7.31507 89.8749 7.51014C89.9721 7.60767 90.1665 7.60767 90.2637 7.51014C90.3609 7.51014 90.4581 7.60767 90.5553 7.7052C90.8469 7.90026 91.1385 8.09533 91.5273 8.09533C91.6245 8.09533 91.6245 8.09533 91.7217 8.09533C92.3049 7.90026 92.2077 7.21754 92.2077 6.92494C92.2077 6.92494 92.2077 6.82741 92.2077 6.72988C92.3049 6.72988 92.3049 6.82741 92.4021 6.82741C92.7909 7.02248 93.2769 7.21754 93.6657 7.02248C93.8601 6.92494 93.9573 6.72988 93.8601 6.53482C93.7629 6.33975 93.4714 6.24222 93.2769 6.33975Z"
        fill="url(#paint2_linear_11_15627)"
      />
      <path
        d="M88.9024 4.97428C88.9996 4.97428 89.0968 4.87675 89.194 4.87675C89.2912 4.87675 89.3884 4.87675 89.3884 4.87675C89.7772 4.97428 90.166 4.97428 90.4576 4.77922C90.8464 4.48662 90.9436 4.0965 90.8464 3.60884C90.8464 3.5113 90.8464 3.31624 90.8464 3.31624C90.9436 3.31624 91.0408 3.31624 91.138 3.31624C91.5268 3.41377 92.0128 3.31624 92.3044 3.02364C92.4988 2.92611 92.4988 2.63352 92.4016 2.43845C92.3044 2.24339 92.0128 2.24339 91.8184 2.34092C91.624 2.43845 91.3324 2.53598 91.138 2.43845C90.7492 2.34092 90.4576 2.43845 90.166 2.73105C89.9716 3.02364 89.9716 3.31624 89.9716 3.60884C89.9716 3.90143 89.9716 3.99896 89.8744 3.99896C89.7772 4.0965 89.5828 3.99896 89.3884 3.99896C89.0968 3.90143 88.708 3.8039 88.4164 4.19403C88.3192 4.38909 88.3192 4.58416 88.5136 4.68169C88.708 4.97428 88.8052 4.97428 88.9024 4.97428Z"
        fill="url(#paint3_linear_11_15627)"
      />
      <path
        d="M89.6797 1.46298C89.6797 1.56051 89.6797 1.56051 89.7769 1.65805H89.8741L90.3601 1.46298C90.4573 1.36545 90.5545 1.36545 90.6517 1.46298L91.1377 1.65805C91.2349 1.65805 91.2349 1.65804 91.3321 1.56051V1.46298L91.1377 0.97532C91.0405 0.877788 91.0405 0.780257 91.1377 0.682725L91.3321 0.195065C91.3321 0.0975328 91.3321 0.097532 91.2349 0H91.1377L90.6517 0.195065C90.5545 0.292597 90.4573 0.292597 90.3601 0.195065L89.8741 0C89.7769 0 89.7769 3.70602e-07 89.6797 0.0975324V0.195065L89.8741 0.682725C89.9713 0.780257 89.9713 0.877788 89.8741 0.97532L89.6797 1.46298Z"
        fill="url(#paint4_linear_11_15627)"
      />
      <path
        d="M95.6094 4.68137C95.6094 4.58384 95.6094 4.48631 95.6094 4.38878L95.8038 3.90112C95.8038 3.80359 95.8038 3.80359 95.7066 3.70605H95.6094L95.1234 3.90112C95.0262 3.90112 94.929 3.90112 94.8318 3.90112L94.3458 3.70605C94.2486 3.70605 94.2486 3.70606 94.1514 3.80359V3.90112L94.3458 4.38878C94.3458 4.48631 94.3458 4.58384 94.3458 4.68137L94.1514 5.16903C94.1514 5.26657 94.1514 5.26657 94.2486 5.3641H94.3458L94.8318 5.16903C94.929 5.16903 95.0262 5.16903 95.1234 5.16903L95.6094 5.3641C95.7066 5.3641 95.7066 5.3641 95.8038 5.26657V5.16903L95.6094 4.68137Z"
        fill="url(#paint5_linear_11_15627)"
      />
      <path
        d="M83.8485 2.82846L84.2374 2.6334C84.3346 2.6334 84.4318 2.6334 84.529 2.6334L84.9178 2.82846H85.015V2.73093L84.8206 2.3408C84.8206 2.24327 84.8206 2.14574 84.8206 2.04821L85.015 1.65808V1.56055H84.9178L84.529 1.75561C84.4318 1.75561 84.3346 1.75561 84.2374 1.75561L83.8485 1.56055H83.7514V1.65808L83.9457 2.04821C83.9457 2.14574 83.9457 2.24327 83.9457 2.3408L83.7514 2.73093C83.6541 2.82846 83.6541 2.82846 83.8485 2.82846C83.7513 2.82846 83.7513 2.82846 83.8485 2.82846Z"
        fill="url(#paint6_linear_11_15627)"
      />
      <path
        d="M108.95 96.0507H21.1777L37.2159 22.0239H125.085L108.95 96.0507Z"
        fill="white"
      />
      <path
        d="M108.95 96.0507H21.1777L37.2159 22.0239H125.085L108.95 96.0507Z"
        fill="#D5DAE8"
      />
      <path
        d="M58.3085 96.0507H40.1319C36.8271 96.0507 34.1054 93.2223 34.2998 89.9062L37.2159 22.0239H41.5899L58.3085 96.0507Z"
        fill="url(#paint7_linear_11_15627)"
      />
      <path
        d="M144.331 96.0507H56.5588L41.6871 39.1896L41.5899 38.7994L37.2158 22.0239H125.085L128.876 36.5562L129.459 38.7994L129.557 39.1896L144.331 96.0507Z"
        fill="white"
      />
      <path
        d="M129.459 38.7994H41.5899L37.2158 22.0239H125.085L128.876 36.5562L129.459 38.7994Z"
        fill="#F3F5FA"
      />
      <path
        opacity="0.3"
        d="M60.3497 34.0204C62.0675 34.0204 63.4601 32.623 63.4601 30.8993C63.4601 29.1756 62.0675 27.7783 60.3497 27.7783C58.6318 27.7783 57.2393 29.1756 57.2393 30.8993C57.2393 32.623 58.6318 34.0204 60.3497 34.0204Z"
        fill="#172D45"
      />
      <path
        opacity="0.3"
        d="M111.672 34.0204C113.39 34.0204 114.782 32.623 114.782 30.8993C114.782 29.1756 113.39 27.7783 111.672 27.7783C109.954 27.7783 108.562 29.1756 108.562 30.8993C108.562 32.623 109.954 34.0204 111.672 34.0204Z"
        fill="#172D45"
      />
      <path
        d="M59.5725 32.167C58.9893 32.167 58.5033 31.6794 58.5033 31.0942C58.5033 30.509 58.9893 30.0213 59.5725 30.0213C61.711 30.0213 63.9466 26.9979 63.9466 22.4138C63.9466 22.3163 63.9466 22.1213 63.9466 22.0237C63.8494 17.5372 61.6138 14.8063 59.5725 14.8063C57.6285 14.8063 55.4901 17.4397 55.1985 21.5361H52.9629C53.2545 16.4644 56.0733 12.6606 59.4753 12.6606C63.0718 12.6606 65.8906 16.8545 66.085 22.2188C66.085 22.3163 66.085 22.4138 66.085 22.5114C66.1822 27.8756 63.2662 32.167 59.5725 32.167Z"
        fill="#1C3754"
      />
      <path
        d="M110.603 32.167C110.02 32.167 109.534 31.6794 109.534 31.0942C109.534 30.509 110.02 30.0213 110.603 30.0213C112.741 30.0213 114.977 26.9979 114.977 22.4138C114.977 22.3163 114.977 22.1213 114.977 22.0237C114.88 17.5372 112.644 14.8063 110.603 14.8063C108.659 14.8063 106.52 17.4397 106.229 21.5361H103.993C104.285 16.4644 107.104 12.6606 110.506 12.6606C114.102 12.6606 116.921 16.8545 117.115 22.2188C117.115 22.3163 117.115 22.4138 117.115 22.5114C117.212 27.8756 114.296 32.167 110.603 32.167Z"
        fill="#1C3754"
      />
      <path
        d="M10 95.9531H151.427"
        stroke="#EAEEF9"
        stroke-width="2.43333"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M112.159 60.7441C111.575 60.7441 111.187 60.2564 111.187 59.7688C111.187 59.1836 111.575 58.7935 112.159 58.7935H115.172C115.755 58.7935 116.144 59.2811 116.144 59.7688C116.144 60.354 115.658 60.7441 115.172 60.7441H112.159Z"
        fill="#D5DAE8"
      />
      <path
        d="M70.7501 88.2482C70.3613 88.2482 69.9725 87.9556 69.7781 87.5654L68.2229 81.811H60.544C59.9608 81.811 59.572 81.3234 59.572 80.8357C59.572 80.2505 60.058 79.8604 60.544 79.8604H67.6397L65.2097 71.2776H57.8224C57.2392 71.2776 56.8504 70.7899 56.8504 70.3023C56.8504 69.7171 57.2392 69.3269 57.8224 69.3269H64.6265L62.1965 60.7441H55.198C54.6148 60.7441 54.226 60.2565 54.226 59.7688C54.226 59.1836 54.6148 58.7935 55.198 58.7935H61.7105L59.2804 50.2107H52.5736C51.9904 50.2107 51.6016 49.723 51.6016 49.2353C51.6016 48.6502 51.9904 48.26 52.5736 48.26H58.6972L57.7252 44.7489C57.628 44.2612 57.9196 43.676 58.4056 43.5785C58.5028 43.5785 58.6 43.5785 58.6972 43.5785C59.086 43.5785 59.4748 43.8711 59.6692 44.2612L60.8356 48.26H68.6117C69.1949 48.26 69.5837 48.6502 69.5837 49.2353C69.5837 49.8205 69.1949 50.2107 68.6117 50.2107H61.4189L63.8489 58.7935H76.0962L72.2081 44.7489C72.1109 44.2612 72.4025 43.676 72.8885 43.5785C72.9858 43.5785 73.083 43.5785 73.1802 43.5785C73.569 43.5785 73.9578 43.8711 74.1522 44.2612L75.3186 48.26H79.4982C80.0814 48.26 80.4702 48.6502 80.4702 49.2353C80.4702 49.8205 79.9842 50.2107 79.4982 50.2107H75.9018L78.3318 58.7935H86.5939C87.1771 58.7935 87.5659 59.2811 87.5659 59.7688C87.5659 60.354 87.1771 60.7441 86.5939 60.7441H78.915L81.345 69.3269H93.6895L88.3435 50.2107H85.7191C85.1359 50.2107 84.7471 49.723 84.7471 49.2353C84.7471 48.6502 85.2331 48.26 85.7191 48.26H87.7603L86.7883 44.7489C86.6911 44.4563 86.7883 44.2612 86.8855 43.9686C86.9827 43.7736 87.1771 43.5785 87.4687 43.481C87.5659 43.481 87.6631 43.481 87.7603 43.481C88.1491 43.481 88.5379 43.7736 88.7323 44.1637L89.8987 48.1625H91.9399C92.5231 48.1625 92.9119 48.5526 92.9119 49.1378C92.9119 49.723 92.5231 50.1131 91.9399 50.1131H90.4819L92.9119 58.696H105.256L102.826 50.1131H96.5084C95.9252 50.1131 95.5364 49.6255 95.5364 49.1378C95.5364 48.5526 96.0224 48.1625 96.5084 48.1625H101.952L100.98 44.6513C100.882 44.1637 101.174 43.5785 101.66 43.481C101.757 43.481 101.854 43.481 101.952 43.481C102.34 43.481 102.729 43.7736 102.924 44.1637L104.09 48.1625H116.435L115.463 44.6513C115.365 44.1637 115.657 43.5785 116.143 43.481C116.24 43.481 116.337 43.481 116.435 43.481C116.823 43.481 117.212 43.7736 117.407 44.1637L118.573 48.1625H126.155C126.738 48.1625 127.127 48.5526 127.127 49.1378C127.127 49.723 126.738 50.1131 126.155 50.1131H118.865L121.295 58.696H128.585C129.168 58.696 129.557 59.1836 129.557 59.6713C129.557 60.2565 129.168 60.6466 128.585 60.6466H121.878L124.308 69.2294H131.306C131.889 69.2294 132.278 69.7171 132.278 70.2047C132.278 70.7899 131.889 71.18 131.306 71.18H124.891L127.321 79.7629H133.931C134.514 79.7629 134.903 80.2505 134.903 80.7382C134.903 81.3234 134.417 81.7135 133.931 81.7135H127.807L129.265 86.8827C129.362 87.3704 129.071 87.9556 128.585 88.0531C128.487 88.0531 128.39 88.0531 128.293 88.0531C127.904 88.0531 127.515 87.7605 127.321 87.3704L125.766 81.7135H113.421L114.879 86.7852C114.977 87.0778 114.879 87.2728 114.782 87.5654C114.685 87.7605 114.491 87.9556 114.199 88.0531C114.102 88.0531 114.005 88.0531 113.907 88.0531C113.519 88.0531 113.13 87.7605 112.935 87.3704L111.38 81.811H99.0356L100.494 86.8827C100.591 87.3704 100.299 87.9556 99.8132 88.0531C99.716 88.0531 99.6188 88.0531 99.5216 88.0531C99.1328 88.0531 98.744 87.7605 98.5496 87.3704L96.9944 81.811H84.6499L86.1079 86.8827C86.2051 87.3704 85.9135 87.9556 85.4275 88.0531C85.3303 88.0531 85.2331 88.0531 85.1359 88.0531C84.7471 88.0531 84.3583 87.7605 84.1639 87.3704L82.6086 81.811H70.2641L71.7221 86.9802C71.8193 87.2728 71.7221 87.4679 71.6249 87.7605C71.5277 87.9556 71.3333 88.1506 71.0417 88.2482C70.9445 88.2482 70.8473 88.2482 70.7501 88.2482ZM98.4524 79.8604H125.183L122.753 71.2776H110.408L111.283 74.3986C111.38 74.6912 111.283 74.8863 111.186 75.1789C111.088 75.3739 110.894 75.569 110.602 75.6665C110.505 75.6665 110.408 75.6665 110.311 75.6665C109.922 75.6665 109.533 75.3739 109.339 74.9838L108.367 71.3751H104.673C104.09 71.3751 103.701 70.8875 103.701 70.3998C103.701 69.8146 104.09 69.4245 104.673 69.4245H107.784L105.354 60.8417H93.1063L95.5364 69.4245H98.5496C99.1328 69.4245 99.5216 69.9121 99.5216 70.3998C99.5216 70.985 99.1328 71.3751 98.5496 71.3751H96.0224L98.4524 79.8604ZM84.0667 79.8604H96.4112L93.9811 71.2776H81.6366L84.0667 79.8604ZM69.6809 79.8604H82.0254L79.5954 71.2776H75.999C75.4158 71.2776 75.027 70.7899 75.027 70.3023C75.027 69.7171 75.513 69.3269 75.999 69.3269H79.1094L76.6794 60.7441H64.3349L66.7649 69.3269H69.9725C70.5557 69.3269 70.9445 69.8146 70.9445 70.3023C70.9445 70.8875 70.4585 71.2776 69.9725 71.2776H67.3481L69.6809 79.8604ZM109.922 69.3269H122.267L116.921 50.2107H104.479L109.922 69.3269Z"
        fill="#D5DAE8"
      />
      <path
        d="M78.0402 55.0871C76.7766 57.0378 76.1934 59.3785 76.3878 61.7193C76.485 63.9625 77.3598 66.2058 78.7206 68.0589C80.0814 69.8145 82.0255 71.2774 84.1639 71.8626C86.3023 72.5454 88.6351 72.4478 90.7735 71.8626C92.8148 71.1799 94.6616 69.8145 95.6336 67.9614C96.6056 66.1082 96.7028 63.865 95.7308 62.1094C94.856 60.2563 93.0092 58.8909 90.9679 58.1106C88.9267 57.2328 86.5939 56.8427 84.2611 56.7452C83.3863 56.7452 82.8031 55.9649 82.8031 55.1847C82.8031 54.3069 83.5807 53.7217 84.3583 53.7217C86.9827 53.9167 89.6071 54.3069 92.0372 55.3797C94.4672 56.4526 96.8972 58.2082 98.1608 60.939C98.744 62.207 99.1328 63.7675 99.0356 65.2305C98.9384 66.6934 98.5496 68.1564 97.8692 69.3268C96.5084 71.8626 94.0784 73.6182 91.454 74.3985C88.8295 75.1787 86.0107 75.0812 83.4835 74.2034C80.9563 73.3256 78.7206 71.57 77.1654 69.4243C75.6102 67.2786 74.7354 64.6453 74.6382 62.0119C74.541 59.3785 75.4158 56.6476 76.8738 54.5019C77.0682 54.2093 77.5542 54.1118 77.943 54.3069C78.1374 54.3069 78.2346 54.7945 78.0402 55.0871Z"
        fill="url(#paint8_linear_11_15627)"
      />
      <g filter="url(#filter1_d_11_15627)">
        <path
          d="M155.62 86.5999C155.523 86.8925 155.523 87.2826 155.426 87.5752C155.134 88.648 154.842 89.6234 154.356 90.5012C152.121 95.4753 147.844 99.1814 142.692 100.644C142.401 100.742 142.109 100.84 141.915 100.84C139.29 101.522 136.471 101.62 133.653 101.034C123.641 98.9863 117.129 89.0384 119.267 78.9926C121.308 68.9468 131.223 62.4118 141.234 64.5575C144.831 65.3378 148.039 67.0936 150.566 69.6294C154.94 74.0183 156.884 80.4554 155.62 86.5999Z"
          fill={theme.colors.primary["500"]}
        />
      </g>
      <path
        d="M154.343 90.491C152.107 95.4652 147.831 99.1714 142.679 100.634L134.028 91.954L133.348 87.9552L140.055 87.1749L140.735 76.9341L154.343 90.491Z"
        fill={theme.colors.primary["500"]}
      />
      <path
        d="M129.906 87.3271C129.906 86.2543 131.073 86.742 131.753 84.4012C132.531 81.5728 131.364 78.8419 134.377 76.5011C134.572 76.306 134.864 76.2085 135.155 76.0134C135.252 75.9159 135.35 75.8184 135.35 75.7208C135.252 74.648 136.03 73.6727 137.099 73.5751C138.168 73.4776 139.14 74.2578 139.238 75.3307C139.238 75.4282 139.238 75.5258 139.238 75.5258C139.238 75.7208 139.335 75.8184 139.432 75.9159C141.57 76.9887 142.445 78.8419 142.542 81.1826C142.931 86.4494 144.098 85.6691 144.778 86.5469C145.361 87.4247 144.486 88.4 143.32 88.4C131.656 88.7901 129.906 88.8877 129.906 87.3271Z"
        fill="url(#paint11_linear_11_15627)"
      />
      <path
        d="M136.614 91.9108C135.642 91.5207 135.156 90.4478 135.544 89.5701C135.544 89.4725 135.642 89.375 135.836 89.375C136.905 89.375 137.877 89.375 138.946 89.375C139.044 89.375 139.238 89.4725 139.238 89.5701C139.53 90.2528 139.238 91.1306 138.752 91.6182C138.072 92.0084 137.294 92.2034 136.614 91.9108Z"
        fill="url(#paint12_linear_11_15627)"
      />
      <defs>
        <filter
          id="filter0_d_11_15627"
          x="0.69796"
          y="45.3342"
          width="38.0445"
          height="40.7144"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8.41021" />
          <feGaussianBlur stdDeviation="6.72817" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_15627"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_15627"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_11_15627"
          x="105.404"
          y="59.1033"
          width="64.0523"
          height="64.1822"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8.41021" />
          <feGaussianBlur stdDeviation="6.72817" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_15627"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_15627"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_11_15627"
          x1="16.7297"
          y1="51.6552"
          x2="24.8357"
          y2="61.6116"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#78B700" />
          <stop offset="1" stop-color="#69A000" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11_15627"
          x1="85.1906"
          y1="1.07275"
          x2="85.1906"
          y2="12.7766"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0208333" stop-color="#FFC46B" />
          <stop offset="1" stop-color="#F79B11" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11_15627"
          x1="91.8061"
          y1="5.89795"
          x2="91.8061"
          y2="8.09533"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0208333" stop-color="#FFC46B" />
          <stop offset="1" stop-color="#F79B11" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_11_15627"
          x1="90.409"
          y1="2.27686"
          x2="90.409"
          y2="4.97428"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0208333" stop-color="#FFC46B" />
          <stop offset="1" stop-color="#F79B11" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_11_15627"
          x1="90.5059"
          y1="0"
          x2="90.5059"
          y2="1.65805"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0208333" stop-color="#FFC46B" />
          <stop offset="1" stop-color="#F79B11" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_11_15627"
          x1="94.9776"
          y1="3.70605"
          x2="94.9776"
          y2="5.3641"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0208333" stop-color="#FFC46B" />
          <stop offset="1" stop-color="#F79B11" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_11_15627"
          x1="84.3512"
          y1="1.56055"
          x2="84.3512"
          y2="2.82846"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0208333" stop-color="#FFC46B" />
          <stop offset="1" stop-color="#F79B11" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_11_15627"
          x1="34.2821"
          y1="59.0262"
          x2="58.3443"
          y2="59.0262"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D5DAE8" />
          <stop offset="1" stop-color="#9AA3BA" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_11_15627"
          x1="86.8407"
          y1="53.7217"
          x2="86.8407"
          y2="74.9275"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0208333" stop-color="#FFC46B" />
          <stop offset="1" stop-color="#F79B11" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_11_15627"
          x1="127.453"
          y1="67.5918"
          x2="147.993"
          y2="98.7636"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#78B700" />
          <stop offset="1" stop-color="#69A000" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_11_15627"
          x1="139.348"
          y1="82.327"
          x2="147.326"
          y2="89.4545"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#78B700" />
          <stop offset="1" stop-color="#78B700" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_11_15627"
          x1="143.281"
          y1="90.0557"
          x2="132.708"
          y2="79.5176"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0113208" stop-color="#C2D1FF" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_11_15627"
          x1="140.232"
          y1="93.1162"
          x2="129.658"
          y2="82.5782"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0113208" stop-color="#C2D1FF" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SolveDurationIcon;
